import React from 'react';
import PropTypes from 'prop-types';
import { isEmpty } from 'lodash';
import classnames from 'classnames';
import DefaultMenuRenderer from 'react-select/lib/utils/defaultMenuRenderer';

import { Column, Row } from 'components/layout';
import selectMenuFactory from './select-menu-factory';

import styles from './select-menu-with-header.less';

const selectMenuWithHeaderRenderer = ({
  menuTitle,
  menuLink,
  detachMenu,
  ...otherProps
}) => {
  return (
    <Column gutter={false}>
      <Row
        data-test-id="select-menu-with-header-header"
        alignItems="center"
        gutterSm
        gutterTop={false}
        gutterBottom={false}
        className={classnames(styles.header, {
          [styles['is-menu-detached']]: detachMenu,
        })}
      >
        <span
          data-test-id="select-menu-with-header-title"
          className={classnames(styles.title)}
        >
          {menuTitle}
        </span>

        {!isEmpty(menuLink) && (
          <a
            {...menuLink}
            data-test-id="select-menu-with-header-link"
            className={classnames(styles.link)}
          >
            {menuLink.text}
          </a>
        )}
      </Row>

      <DefaultMenuRenderer {...otherProps} />
    </Column>
  );
};

selectMenuWithHeaderRenderer.propTypes = {
  ...DefaultMenuRenderer.propTypes,
  detachMenu: PropTypes.bool,
  menuLink: PropTypes.shape({
    text: PropTypes.string,
    href: PropTypes.string,
    target: PropTypes.string,
    rel: PropTypes.string,
  }),
  menuTitle: PropTypes.string,
};

selectMenuWithHeaderRenderer.defaultProps = {
  ...DefaultMenuRenderer.defaultProps,
  detachMenu: false,
  menuLink: {},
  menuTitle: '',
};

// Decorate the SelectMenuWithHeader with our custom selectMenuFactory
// so that we apply the auto placement logic for the menu.
const SelectMenuWithHeader = selectMenuFactory(selectMenuWithHeaderRenderer);

export default SelectMenuWithHeader;
export { SelectMenuWithHeader, selectMenuWithHeaderRenderer };
